import React, { PropsWithChildren } from 'react'
import { Icon } from '@chakra-ui/icons'
import { Flex } from '@chakra-ui/react'
import { FaCircle, FaCircleCheck } from 'react-icons/fa6'

import { useMessageProperties } from './message-provider'
import { useExportMessages } from '../../export-messages-context'

export default function ExportSelectWrapper({ children }: PropsWithChildren) {
    const { isExporting, selectedMessages, setSelectedMessages } =
        useExportMessages()
    const { message } = useMessageProperties()

    const isSelected = selectedMessages.some(m => m.id === message.id)

    function handleClick() {
        if (selectedMessages.some(m => m.id === message.id)) {
            setSelectedMessages(
                selectedMessages.filter(m => m.id !== message.id),
            )
        } else {
            setSelectedMessages([...selectedMessages, message])
        }
    }

    return (
        <Flex
            px={6}
            rounded="md"
            flexDir="row"
            alignItems="center"
            gridGap={3}
            _hover={
                isExporting
                    ? {
                          cursor: 'pointer',
                          bg: 'gray.50',
                      }
                    : {}
            }
            onClick={isExporting ? handleClick : undefined}
        >
            {children}
            {isExporting && (
                <Icon
                    as={isSelected ? FaCircleCheck : FaCircle}
                    color={isSelected ? 'brand.500' : 'gray.300'}
                />
            )}
        </Flex>
    )
}
